import type { Router } from 'vue-router'
import i18n, { LOCALES, DEFAULT_LOCALE } from '@/i18n'
import type { Locale } from '@/types'

export function setupGuards(router: Router) {
  router.beforeEach((to) => {
    // Extract locale from path or route meta (routes use static paths, not :locale param)
    const locale = (to.meta.locale as string) ?? to.path.split('/')[1]

    if (!locale || !LOCALES.includes(locale as Locale)) {
      return
    }

    const i18nGlobal = i18n.global
    if (i18nGlobal.locale.value !== locale) {
      i18nGlobal.locale.value = locale as Locale
    }

    document.documentElement.lang = locale
  })
}
